import { Card, Col, Row, Space } from "antd"
import { useEffect, useMemo, useState } from "react"
import { useNavigate } from "react-router-dom"
import { styled } from "styled-components"
import { IconCashRegisterSolid, IconCircleUserSolid, IconHouseCircleExclamationSolid, IconHouseSolid, IconMapLocationDotSolid } from "../../../icon"
import { useGetCustomersQuery, useGetEmployeesQuery, useGetTasksQuery } from "../../../api/plamo-api"
import { useUserContext } from "../../oidc"
import helfendeelfen from '../../../image-240x185.png'

const FadeInCard = styled(Card)`
  width: 240px;
  transform: scale(1);

  &.hidden {
    transform: scale(0);
    opacity: 0.0;
  }

  transition: opacity 1s, transform 1s, box-shadow 0.5s;
`

const FadeInCardCounter = styled.div`
  position: absolute;
  font-size: 50%;
  left: 1em;
  top: 0.5em;
`

const FadeInCardCounterAnimate = ({ value }) => {
  const [currentValue, setCurrentValue] = useState<number>(0);
  const stepCnt = 50;
  const step = Math.ceil(value / stepCnt);

  //console.log("Counter value", value);

  useEffect(() => {
    if(value === undefined) {
      return;
    }
    let count = 0;
    const interval = setInterval(() => {
      setCurrentValue(currentValue => { /* console.log("Current value", currentValue, step, value / stepCnt, value); */ return Math.min(currentValue + step, value) })
      count += 1;
      if(count === stepCnt + 2) {
        clearInterval(interval);
      }
    }, 50)
  }, [setCurrentValue, step, value, stepCnt])
      
  return value === undefined ? <></> : <FadeInCardCounter>{ currentValue }</FadeInCardCounter>
}

function LandingPage() {
  const [displayCard, setDisplayCard] = useState<number>(0)
  const userContext = useUserContext()
  const userId = userContext?.user?.id;
  const navigate = useNavigate()

  const { data: activeCustomers, isLoading: activeCustomersLoading } = useGetCustomersQuery({ c: 1, f: JSON.stringify({ status: { c: "EQ", v: "Aktiv" }})}) as any;
  const { data: activeEmployees, isLoading: activeEmployeesLoading } = useGetEmployeesQuery({ c: 1, f: JSON.stringify({ active: { c: "EQ", v: true }})}) as any;
  const { data: tasksCustomers, isLoading: tasksCustomersLoading } = useGetTasksQuery({ f: JSON.stringify({ objectType: { c: "EQ", v: "customer" }, assignedUserId: { c: "EQ", v: userId } }) }) as any
  const { data: tasksEmployees, isLoading: tasksEmployeesLoading } = useGetTasksQuery({ f: JSON.stringify({ objectType: { c: "EQ", v: "employee" }, assignedUserId: { c: "EQ", v: userId } }) }) as any
  
  useEffect(() => {
    let myDisplayCard = -2;
    const interval = setInterval(() => {
      myDisplayCard++;
      setDisplayCard(myDisplayCard);
      if(myDisplayCard > 4) {
        clearInterval(interval);
      }
    }, 250)
  }, [setDisplayCard])

  const optionsTodos = useMemo(() => [
    {
      key: "todos-customers",
      icon: <IconHouseCircleExclamationSolid />,
      label: "Todos Kunden",
      onClick: () => navigate(`/task?filter=${btoa(JSON.stringify({ 
        objectType: { 
          comparator: "EQ", 
          value: "customer", 
          type: 'STRING', 
          originalValue: "Kunde", 
          displayValue: "Kunde", 
          title: "Objekttyp" 
        },
        solved: {
          comparator: "EQ",
          value: false,
          originalValue: 'offen',
          displayValue: 'offen',
          title: "Status"
        },
        assignedUserId: {
          comparator: "EQ",
          value: userId,
          originalValue: "Aktueller User",
          displayValue: "Aktueller User",
          title: "Zugewiesen an"
        }
      }))}`),
      count: tasksCustomersLoading ? undefined : tasksCustomers?.totalCnt
    },
    {
      key: "todos-employees",
      icon: <IconCircleUserSolid />,
      label: "Todos Mitarbeiter",
      onClick: () => navigate(`/task?filter=${btoa(JSON.stringify({ 
        objectType: { 
          comparator: "EQ", 
          value: "employee", 
          type: 'STRING', 
          originalValue: "Mitarbeiter", 
          displayValue: "Mitarbeiter", 
          title: "Objekttyp" 
        },
        solved: {
          comparator: "EQ",
          value: false,
          originalValue: 'offen',
          displayValue: 'offen',
          title: "Status"
        },
        assignedUserId: {
          comparator: "EQ",
          value: userId,
          originalValue: "Aktueller User",
          displayValue: "Aktueller User",
          title: "Zugewiesen an"
        }
      }))}`),
      count: tasksEmployeesLoading ? undefined : tasksEmployees?.totalCnt
    },
  ], [tasksCustomersLoading, tasksCustomers?.totalCnt, tasksEmployeesLoading, 
    tasksEmployees?.totalCnt, navigate, userId])

  const options = useMemo(() => [
    {
      key: "customers",
      icon: <IconHouseSolid />,
      label: "Kunden",
      onClick: () => navigate(`/customer?filter=${btoa(JSON.stringify({ status: { comparator: "EQ", value: "Aktiv", originalValue: "Aktiv", displayValue: "Aktiv", title: "Status" }}))}&sort=${JSON.stringify({ lastName: 'asc' })}`),
      count: activeCustomersLoading ? undefined : activeCustomers?.totalCnt
    },
    {
      key: "employees",
      icon: <IconCircleUserSolid />,
      label: "Mitarbeitende",
      onClick: () => navigate(`/employee?filter=${btoa(JSON.stringify({ active: { comparator: "EQ", value: true, originalValue: "Aktiv", displayValue: "Aktiv", title: "Status" }}))}&sort=${JSON.stringify({ lastName: 'asc' })}`),
      count: activeEmployeesLoading ? undefined : activeEmployees?.totalCnt
    },
    {
      key: "map",
      icon: <IconMapLocationDotSolid />,
      label: "Karte",
      onClick: () => navigate(`/map`)
    },
    {
      key: "settlement",
      icon: <IconCashRegisterSolid />,
      label: "Abrechnung",
      onClick: () => navigate(`/settlement`)
    },
  ], [navigate, activeCustomers?.totalCnt, activeEmployees?.totalCnt, activeCustomersLoading, activeEmployeesLoading])  

  return (
    <>
    { false && 
      <Row style={{ marginTop: '2em' }}>
        <Col flex="1"></Col>
        <img src={helfendeelfen} alt="Mandanten-Logo" />
      </Row> }
      <Row style={{ marginTop: '2em' }}>
        <Col flex="1"></Col>
        <Col>
          <h1>Meine Todos</h1>
          <Space size="large">
            { 
              optionsTodos.map((option, idx) => {
                return <FadeInCard
                  key={option.key}
                  onClick={option.onClick}
                  hoverable
                  className={[displayCard <= idx ? "hidden": undefined].filter(i => !!i).join(" ")}
                  cover={<div style={{ textAlign: "center", fontSize: '300%', padding: '0.5em', color: "rgba(0, 0, 0, 0.88)" }}>{ displayCard > idx && <FadeInCardCounterAnimate value={option.count} />}{ option.icon }</div>}
                >
                  <Card.Meta title={ <div style={{ textAlign: 'center' }}>{option.label}</div> } />
                </FadeInCard>
              })
            }
          </Space>
        </Col>
        <Col flex="1"></Col>
      </Row>
      <Row style={{ marginTop: '2em' }}>
        <Col flex="1"></Col>
        <Col>
          <h1>Sonstiges</h1>
          <Space size="large">
            { 
              options.map((option, idx) => {
                return <FadeInCard
                  key={option.key}
                  onClick={option.onClick}
                  hoverable
                  className={[displayCard <= idx ? "hidden": undefined].filter(i => !!i).join(" ")}
                  cover={<div style={{ textAlign: "center", fontSize: '300%', padding: '0.5em', color: "rgba(0, 0, 0, 0.88)" }}>{ displayCard > idx && <FadeInCardCounterAnimate value={option.count} />}{ option.icon }</div>}
                >
                  <Card.Meta title={ <div style={{ textAlign: 'center' }}>{option.label}</div> } />
                </FadeInCard>
              })
            }
          </Space>
        </Col>
        <Col flex="1"></Col>
      </Row>
    </>
  )
}

export default LandingPage